export const Cart = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M28.1641 7.21497L26.0173 16.9219C26.0072 16.9677 25.9666 17.0003 25.9197 17.0003H6.5" stroke="currentColor" stroke-width="2"/>
<path d="M16.2808 2.71021L21.5266 8.03029L16.2996 13.2991" stroke="currentColor" stroke-width="2"/>
<path d="M11 8.00464L21 8.00464" stroke="currentColor" stroke-width="2"/>
<circle cx="24" cy="28" r="2" fill="currentColor"/>
<circle cx="10" cy="28" r="2" fill="currentColor"/>
<path d="M0 3H3.91802C3.96569 3 4.00673 3.03365 4.01608 3.08039L7.98392 22.9196C7.99327 22.9664 8.03431 23 8.08198 23H26" stroke="currentColor" stroke-width="2"/>
</svg>`;
